module.exports = __webpack_public_path__ + "static/assessment-0ff875aab1f58884325c9f9d500373f6.jpg";